import { render, staticRenderFns } from "./aiSrt.vue?vue&type=template&id=61a658aa"
import script from "./aiSrt.vue?vue&type=script&lang=js"
export * from "./aiSrt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports